
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const EmailMarketingLanding = dynamic(async () => await import('@/templates/Landing/EmailMarketing/EmailMarketingLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Create Stunning AI-Generated Email Marketing Visuals | Lift' description='Effortlessly create branded, high-converting email visuals with Lift. Use smart templates, AI design tools, and automation to generate banners, product showcases, and headers that grab attention and drive results.' ogTitle='Lift: AI Tools to Boost Your Email Marketing Visuals' ogDescription='Lift helps marketers, agencies, and e-commerce brands generate professional-looking email marketing visuals in seconds using AI. Boost click rates, engagement, and conversions—without hiring a designer.'>
				<EmailMarketingLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/email-marketing-visuals', 'email-marketing-visuals');

    async function __Next_Translate__getServerSideProps__1a1a20bb8c0__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/email-marketing-visuals/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8c0__ as getServerSideProps }
  